import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=e4bc1e54&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4bc1e54')) {
      api.createRecord('e4bc1e54', component.options)
    } else {
      api.reload('e4bc1e54', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=e4bc1e54&", function () {
      api.rerender('e4bc1e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-260B8xsSiTrTi/JS/comp/ImgFallback.vue"
export default component.exports